import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      completionOuterContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 24px 24px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      completionInnerContainer: {
        background: 'white',
        minWidth: '100%',
        borderRadius: '8px',
        height: '879px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('lg')]: {
          height: '1700px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '830px'
        }
      },
      completionMessage: {
        width: '460px',
        fontSize: '25px',
        margin: '0px 0px 112px 0px',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          width: '550px',
          fontSize: '30px'
        },
        [theme.breakpoints.only('lg')]: {
          margin: '0px 0px 48px 0px',
          fontSize: '28px'
        }
      },
      completionHeader: {
        fontFamily: props.fontFamily,
        textAlign: 'center',
        fontWeight: 800,
        lineHeight: 1,
        fontSize: '100px',
        margin: '0px',
        [theme.breakpoints.only('lg')]: {
          fontSize: '64px'
        }
      }
    })
  );
